import { CloudDownload as DownloadIcon } from "@mui/icons-material";
import { Fab as FloatingActionButton } from "@mui/material";
import { useState } from "react";
import CsvExportDialog from "./CsvExportDialog";
import { getCalculationsCsv } from "../calculationsApi";

const CalculationsCsvExport = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <div>
      <FloatingActionButton color="secondary" title="Kalkulacje" onClick={() => setDialogOpen(true)}>
        <DownloadIcon />
      </FloatingActionButton>
      <CsvExportDialog
        title="Pobierz kalkulacje"
        filename="kalkulacje.csv"
        downloadErrorMessage="Nie udało się pobrać pliku CSV z kalkulacjami"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onDownload={getCalculationsCsv}
      />
    </div>
  );
};

export default CalculationsCsvExport;
